import React, { useState } from 'react';
import { X } from 'lucide-react';
import api from '../api/client';
import endpoints from '../api/endpoints';
import toast from 'react-hot-toast';
import '../assets/css/feedbackModal.css';

const FeedbackModal = ({ message, onClose }) => {
  const [issueType, setIssueType] = useState('');
  const [adminCorrection, setAdminCorrection] = useState('');
  const [adminNotes, setAdminNotes] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const issueTypes = [
    { value: 'factual_error', label: 'Factual Error' },
    { value: 'incomplete', label: 'Incomplete Answer' },
    { value: 'tone', label: 'Tone/Bias Issue' },
    { value: 'hallucination', label: 'Hallucination/Made-up Info' },
    { value: 'formatting', label: 'Formatting Issue' },
    { value: 'other', label: 'Other' }
  ];

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!issueType) {
      toast.error('Please select an issue type');
      return;
    }

    setSubmitting(true);

    try {
      const feedbackData = {
        threadId: message.threadId || null,
        query: message.query || '',
        response: message.content,
        sources: message.sources || [],
        issueType,
        adminCorrection,
        adminNotes
      };

      await api.post(endpoints.feedback.submit, feedbackData);

      toast.success('Feedback submitted successfully! This will help improve Nick\'s responses.');
      onClose();
    } catch (error) {
      console.error('Error submitting feedback:', error);
      toast.error(error.response?.data?.error || 'Failed to submit feedback');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-container" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2 className="modal-title">Report Response Issue</h2>
          <button className="modal-close-button" onClick={onClose}>
            <X size={24} />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="modal-form">
          <div className="form-group">
            <label className="form-label">Original Response</label>
            <div className="response-preview">
              {message.content.substring(0, 200)}
              {message.content.length > 200 && '...'}
            </div>
          </div>

          <div className="form-group">
            <label className="form-label">Issue Type *</label>
            <select
              className="form-select"
              value={issueType}
              onChange={(e) => setIssueType(e.target.value)}
              required
            >
              <option value="">Select issue type</option>
              {issueTypes.map(type => (
                <option key={type.value} value={type.value}>
                  {type.label}
                </option>
              ))}
            </select>
          </div>

          <div className="form-group">
            <label className="form-label">Corrected Response</label>
            <textarea
              className="form-textarea"
              value={adminCorrection}
              onChange={(e) => setAdminCorrection(e.target.value)}
              placeholder="Provide the correct response (optional - helps Nick learn)"
              rows="4"
            />
          </div>

          <div className="form-group">
            <label className="form-label">Additional Notes</label>
            <textarea
              className="form-textarea"
              value={adminNotes}
              onChange={(e) => setAdminNotes(e.target.value)}
              placeholder="Any additional context or notes about this issue..."
              rows="3"
            />
          </div>

          <div className="modal-actions">
            <button
              type="button"
              className="button-secondary"
              onClick={onClose}
              disabled={submitting}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="button-primary"
              disabled={submitting}
            >
              {submitting ? 'Submitting...' : 'Submit Feedback'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default FeedbackModal;
